import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { confirmarCodigoValidacao, cancelarValidacao } from '../../../auth/authActions'

import logo from '../../../assets/img/brand/logo.svg'
import { Button, Card, CardBody, CardGroup, Container, Form, InputGroup, InputGroupAddon, InputGroupText, Row, Col } from 'reactstrap';
import MyToaster from '../../../util/toaster'

// Segunda etapa do login: o backend aceitou usuario/senha e enviou um codigo
// por WhatsApp/e-mail. Enquanto o codigo nao for confirmado nada e gravado no
// localStorage e o usuario nao entra no sistema.
class ValidarToken extends Component {

  constructor(props) {
    super(props)
    this.state = {
      codigo: ""
    }
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.confirmarCodigoValidacao(this.state.codigo)
  }

  render() {
    return (

      <div className="app flex-row align-items-center">

        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="hsm-login">
                <Card className="p-4 hsm-login-form">
                  <CardBody>
                    <Form onSubmit={e => this.onSubmit(e)}>
                      <div className="row" >
                        <div className="col-xs-12 col-sm-12 col-md-12 " >
                          <h1 className="hsm-login-titulo">Validação de Acesso</h1>
                          <p className="text-muted hsm-login-titulo">
                            Enviamos seu código de validação por WhatsApp e/ou e-mail.
                            Informe-o abaixo para concluir seu acesso.
                          </p>
                        </div>
                      </div>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-key"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <input
                          className="form-control"
                          type="text"
                          name="codigoValidacao"
                          placeholder="Seu código de validação"
                          autoComplete="off"
                          autoFocus
                          value={this.state.codigo}
                          onChange={e => this.setState({ codigo: e.target.value })}
                        />
                      </InputGroup>

                      <div className="mb-3 p-3 bg-light border rounded">
                        <p className="mb-2"><strong>Não recebeu o código?</strong></p>
                        <ul className="text-muted mb-0 pl-3">
                          <li>Verifique a caixa de spam/lixo eletrônico do seu e-mail.</li>
                          <li>
                            Se ainda assim não localizar, procure o setor de Cadastro para
                            atualizar seus dados pessoais.
                          </li>
                        </ul>
                      </div>

                      <Row className="justify-content-center">
                        <Button type="submit" className="px-4 hsm-login-form-btn" >Validar e Entrar</Button>
                      </Row>
                      <Row className="justify-content-center mt-3">
                        <Button type="button" color="link" className="text-muted"
                          onClick={() => this.props.cancelarValidacao()} >
                          Voltar para o login
                        </Button>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
                <Card className="bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                  <CardBody className="text-center">
                    <div className="hsm-logo-login container">
                      <img src={logo} alt="Imagem do HSM" />
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
        <MyToaster />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ confirmarCodigoValidacao, cancelarValidacao }, dispatch)
export default connect(null, mapDispatchToProps)(ValidarToken)
